// Schadenpostfach — reine Ordner-Logik des Fensters „Neuer Schaden / Schaden
// zuordnen" (ohne React, damit sie ohne Fenster prüfbar bleibt).
//
// Ein Schaden ist hier ein Ordner IM Ordner „Schaden" der Kundenakte des
// Kontakts (PO 05.10.2026) — kein Schaden-Datensatz, kein Vorgang.

/** Name des Sammelordners, wenn die Akte noch keinen hat. */
export const SCHADEN_BASIS = "Schaden";

/**
 * Den vorhandenen Sammelordner der Akte finden. Alte Akten schreiben ihn
 * uneinheitlich („Schaden", „Schäden", „SCHADEN") — dann wird DER benutzt,
 * statt daneben einen zweiten anzulegen.
 */
export function findeSchadenBasis(wurzelOrdner: readonly string[]): string {
    const norm = (s: string) => s.trim().toLowerCase().replace(/ä/g, "a").replace(/ae/g, "a");
    return wurzelOrdner.find((n) => norm(n) === "schaden") ?? SCHADEN_BASIS;
}

/**
 * Ordnername aus einer Eingabe bzw. dem Mail-Betreff: ohne Antwort-/
 * Weiterleitungs-Präfixe, ohne Zeichen, die in Ordnernamen nichts verloren
 * haben, und nicht länger als ein Ordner sinnvoll heißt.
 */
export function ordnerName(roh: string | null | undefined): string {
    return String(roh ?? "")
        .replace(/^(\s*(aw|re|wg|fw|fwd|antwort|weitergeleitet)\s*:\s*)+/i, "")
        .replace(/[\\/:*?"<>|]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/[. ]+$/, "")
        .slice(0, 80)
        .trim();
}

/**
 * Nach dem Ablegen direkt dorthin, wo die Mail jetzt liegt (Wunsch 22.10.2026):
 * Kontakt → Reiter „Dokumente" → der Schaden-Ordner der Kundenakte.
 * `ordner` ist der Pfad, den der Server zurückmeldet („Schaden/2026/Wasser").
 */
export function schadenOrdnerLink(contactId: number, ordner: string): string {
    const pfad = ordnerAusParam(ordner);
    const q = new URLSearchParams({ tab: "Dokumente" });
    if (pfad) q.set("ordner", pfad);
    return `/contacts/${contactId}?${q.toString()}`;
}

/**
 * `?ordner=` einer Kontaktseite → Explorer-Pfad der Kundenakte (mit „/" am
 * Ende, wie der Explorer ihn führt). Leer, Unsinn oder „.."-Segmente → null.
 */
export function ordnerAusParam(roh: string | null | undefined): string | null {
    const segmente = String(roh ?? "")
        .split("/")
        .map((s) => s.trim())
        .filter(Boolean);
    if (segmente.length === 0 || segmente.some((s) => s === "." || s === "..")) return null;
    return `${segmente.join("/")}/`;
}
